import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ACCOUNT_ROUTE_URLS, ROUTE_URLS } from '@app/app.routes.names';
import { SimpleAuthService } from '@ztarmobile/zwp-services-auth';

@Component({
  selector: 'app-ios-tmo',
  templateUrl: './tmo.component.html',
  styleUrls: ['./tmo.component.scss']
})

export class IosTmoComponent implements OnInit {
  public iosInfoDetails: Array<{ key: string; value: string; href?: boolean }>;
  public isLoggedIn = false;

  constructor(
    private router: Router,
    private simpleAuthService: SimpleAuthService) {

    this.iosInfoDetails = [
      { key: 'APN:', value: 'RESELLER' },
      { key: 'Username:', value: '(Leave blank)' },
      { key: 'Password:', value: '(Leave blank)' },
      { key: 'MMSC:', value: 'http://wholesale.mmsmvno.com/mms/wapenc', href: true },
      { key: 'MMS Proxy:', value: '(Leave blank)' },
      { key: 'MMS Max Message Size:', value: '1048576' },
      { key: 'MMS UA Prof URL:', value: 'https://www.apple.com/mms/uaprof.rdf', href: true }
    ];
  }

  ngOnInit(): void {
    this.simpleAuthService.userState.subscribe((authState) => {
      this.isLoggedIn = !!authState && !authState.isAnonymous;
    });
  }

  public gotIt(): void {
    if (!!this.isLoggedIn) {
      this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.SUMMARY}`]);
    } else {
      this.router.navigate([`${ROUTE_URLS.HOME}`]);
    }
  }
}
